import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumns24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextColumns24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 7.25a.75.75 0 0 1 .75-.75H9.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 7.25m0 5.998a.75.75 0 0 1 .753-.748l4.75.016a.75.75 0 1 1-.006 1.5L4.747 14A.75.75 0 0 1 4 13.248M4.75 9.5a.75.75 0 0 0 0 1.5H8a.75.75 0 0 0 0-1.5zM4 16.25a.75.75 0 0 1 .75-.75H8A.75.75 0 0 1 8 17H4.75a.75.75 0 0 1-.75-.75m9.75-9a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 0 1.5H14.5a.75.75 0 0 1-.75-.75m0 5.998a.75.75 0 0 1 .752-.748l4.75.016a.75.75 0 0 1-.005 1.5L14.497 14a.75.75 0 0 1-.747-.752M14.5 9.5a.75.75 0 0 0 0 1.5h3.25a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h3.25a.75.75 0 0 1 0 1.5H14.5a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumns24);
